import React from "react";
import PropTypes from "prop-types";

const OneDirectionSync = (props) => {
  const { color, width, height, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      {...other}
    >
      <path id="Path_8818" d="M0,0H20V20H0Z" fill="none" />
      <path
        id="Path_8819"
        d="M18.833,11.333,15.5,8v2.5H3v1.667H15.5v2.5Z"
        transform="translate(-0.5 -1.333)"
        fill={color}
      />
    </svg>
  );
};

OneDirectionSync.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

OneDirectionSync.defaultProps = {
  color: "#000000",
  width: 24,
  height: 24,
};

export default OneDirectionSync;



// WEBPACK FOOTER //
// ./src/components/Icons/OneDirectionSync.jsx